import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { Alert } from '@zooplus/ui-components';

// Provided default values are only there for typescript to be happy.
// They will never be used.
const ErrorContext = createContext({
    setError: () => { },
});
const useErrorContext = () => useContext(ErrorContext);
/**
 * Context providing a 'setError' function.
 *
 * Because the components are often embedded in another UI, we need to display any error happening in our app in that external UI, to improve clarity to the user. Hence the use of a portal.
 *
 * Exceptions are:
 * - individual validation error of an input: the message is displayed alongside the input
 * - errors happening when one of our modal is shown: we display ourselves the error in the modal instead of in the portal, because the modal is usually hiding the portal element.
 */
const ErrorContextProvider = ({ errorContainerId, children, }) => {
    const [error, setError] = useState();
    return (jsxs(ErrorContext.Provider, { value: { error, setError }, children: [jsx(ErrorContainerPortal, { errorContainerId: errorContainerId, children: error && (jsx(Alert, { className: "pp-mb-m", "data-zta": "errorCreditCard", variant: error?.variant, children: error?.message })) }), children] }));
};
const ErrorContainerPortal = ({ children, errorContainerId, }) => {
    const errorContainer = document.getElementById(errorContainerId);
    if (!errorContainer)
        return null;
    return createPortal(children, errorContainer);
};

export { ErrorContextProvider as default, useErrorContext };
//# sourceMappingURL=ErrorContextProvider.js.map
